@if (!readonly && isCompletedChange()) {
    <button mat-icon-button
            color="primary"
            (click)="completeChangeClicked()">
        <mat-icon>check_box</mat-icon>
    </button>
}

@if (!readonly && isNotStartedChange()) {
    <button mat-icon-button
            color="primary"
            (click)="notStartedChangeClicked()">
        <mat-icon>check_box_outline_blank</mat-icon>
    </button>
}

@if (!readonly && isNotDoingChange()) {
    <button mat-icon-button
            color="primary"
            (click)="notDoingChangeClicked()">
        <mat-icon>indeterminate_check_box</mat-icon>
    </button>
}

@if (readonly && isCompletedChange()) {
    <mat-icon color="primary"
    >check_box
    </mat-icon>
}
@if (readonly && isNotStartedChange()) {
    <mat-icon>check_box_outline_blank</mat-icon>
}
@if (readonly && isNotDoingChange()) {
    <mat-icon color="warn"
    >indeterminate_check_box
    </mat-icon>
}